import React, { useState } from "react";
import { Car } from "../CarCard/CarCard";
import "./FavoriteList.css";

interface Props {
  allCars: Car[];
  favorites: number[];
  setFavorites: React.Dispatch<React.SetStateAction<number[]>>;
}

const FavoriteList: React.FC<Props> = ({
  allCars,
  favorites,
  setFavorites,
}) => {
  const favoriteCars = allCars.filter((car) => favorites.includes(car.id));

  const [modalOpen, setModalOpen] = useState(false);
  const [modalSrc, setModalSrc] = useState("");

  const openModal = (src: string) => {
    setModalSrc(src);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalSrc("");
  };

  const removeFavorite = (carId: number) => {
    const updatedFavorites = favorites.filter((id) => id !== carId);
    localStorage.setItem("favorites", JSON.stringify(updatedFavorites));
    setFavorites(updatedFavorites);
  };

  if (favoriteCars.length === 0) {
    return <p className="has-text-grey">No favourites selected yet.</p>;
  }

  const returnCarSoldBgClassName = (carSold: boolean): string =>
    carSold ? "car-sold" : "";
  const returnCarSoldViewBtnClassName = (carSold: boolean): string =>
    carSold ? "is-dark" : "is-link";

  return (
    <div className="table-container">
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>Images</th>
            <th>Make, Model, Trim</th>
            <th>Registration</th>
            <th>Mileage</th>
            <th>Insurance Group</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {favoriteCars.map((car) => (
            <tr
              key={car.id}
              className={` ${returnCarSoldBgClassName(car.isCarSold)} `}
            >
              {/* Images column */}
              <td>
                <div className="is-flex is-flex-wrap-wrap">
                  {car.images.map((img, index) => {
                    const imageClassName: string = img.includes("front")
                      ? "first-image"
                      : "last-image";
                    return (
                      <div className="column favorite-thumbnail" key={index}>
                        <img
                          src={`images/${img}`}
                          alt={`${car.make} ${car.model} - ${car.trim}`}
                          className={`thumbnail ${imageClassName}`}
                          onClick={() => openModal(`images/${img}`)}
                        />
                      </div>
                    );
                  })}
                </div>
              </td>

              {/* Detail columns */}
              <td>
                {car.make} {car.model} <br />
                {car.trim}
              </td>
              <td>
                {car.registration}
                {car.isCarSold && (
                  <div className="tag is-black is-medium has-text-warning">
                    SOLD
                  </div>
                )}
              </td>
              <td>{car.mileage.toLocaleString()} miles</td>
              <td>{car.insuranceGroup}</td>
              <td>
                <a
                  href={car.detailsUrl}
                  target="_blank"
                  rel="noreferrer"
                  className={`button is-small ${returnCarSoldViewBtnClassName(
                    car.isCarSold
                  )} `}
                >
                  View
                </a>

                <div
                  className="favorite-toggle mt-4"
                  onClick={() => removeFavorite(car.id)}
                >
                  <button className="button is-small is-rounded">
                    <span className="icon is-small">
                      <i
                        className="fas fa-heart"
                        style={{
                          color: "red",
                          cursor: "pointer",
                          fontSize: "1.2rem",
                          transition: "color 0.3s ease",
                        }}
                        title={"Remove from favorites"}
                      ></i>
                    </span>
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modalOpen && (
        <div className="modal is-active">
          <div className="modal-background" onClick={closeModal}></div>
          <div className="modal-content">
            <p className="image">
              <img src={modalSrc} alt="Large view" />
            </p>
          </div>
          <button
            className="modal-close is-large"
            aria-label="close"
            onClick={closeModal}
          ></button>
        </div>
      )}
    </div>
  );
};

export default FavoriteList;
